import React from 'react'
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Container,
  Heading,
  Text,
  VStack
} from '@chakra-ui/react'
import Link from 'next/link'

export interface Crumb {
  label: string
  href?: string
}

interface WarrantyPageLayoutProps {
  title: string
  breadcrumbs?: Crumb[]
  children: React.ReactNode
}

const WarrantyPageLayout: React.FC<WarrantyPageLayoutProps> = ({
  title,
  breadcrumbs,
  children
}) => {
  return (
    <Container maxW={'640px'} my={{ base: 10, md: 16 }} px={4}>
      <VStack spacing={{ base: 5, md: 7 }} w={'100%'} align={'stretch'}>
        {breadcrumbs && breadcrumbs.length > 0 && (
          <Breadcrumb
            w={'100%'}
            spacing={'8px'}
            fontSize={'sm'}
            color={'gray.500'}
            separator={<Text color={'gray.300'}>/</Text>}
          >
            {breadcrumbs.map((c, i) => {
              const isLast = i === breadcrumbs.length - 1
              return (
                <BreadcrumbItem key={i} isCurrentPage={isLast}>
                  {c.href && !isLast ? (
                    <BreadcrumbLink
                      as={Link}
                      href={c.href}
                      _hover={{ color: '#DE4800', textDecoration: 'none' }}
                    >
                      {c.label}
                    </BreadcrumbLink>
                  ) : (
                    <Text color={'gray.700'} fontWeight={500}>
                      {c.label}
                    </Text>
                  )}
                </BreadcrumbItem>
              )
            })}
          </Breadcrumb>
        )}

        <VStack spacing={3} w={'100%'}>
          <Heading
            as={'h1'}
            w={'100%'}
            textAlign={'center'}
            fontFamily={'ITC'}
            fontWeight={500}
            fontSize={{ base: '26px', md: '36px' }}
            lineHeight={1.15}
            color={'#272726'}
          >
            {title}
          </Heading>
          <Box w={'56px'} h={'3px'} bg={'#DE4800'} borderRadius={'full'} />
        </VStack>

        {children}
      </VStack>
    </Container>
  )
}

export default WarrantyPageLayout
